var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 10.5,
    stroke: "#61CBC9",
    strokeOpacity: 0.5,
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_9910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5715 28.9286H21.4287",
    stroke: "#61CBC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7143 18.2143C25.7143 16.6988 25.1123 15.2453 24.0406 14.1737C22.9689 13.102 21.5155 12.5 20 12.5C18.4844 12.5 17.031 13.102 15.9594 14.1737C14.8877 15.2453 14.2857 16.6988 14.2857 18.2143V23.2143C14.2857 23.7826 14.0599 24.3277 13.6581 24.7296C13.2562 25.1314 12.7111 25.3571 12.1428 25.3571H27.8571C27.2888 25.3571 26.7437 25.1314 26.3418 24.7296C25.94 24.3277 25.7143 23.7826 25.7143 23.2143V18.2143Z",
    stroke: "#61CBC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7144 18.0286C10.7151 16.6688 11.0394 15.3287 11.6604 14.119C12.2814 12.9092 13.1813 11.8646 14.2858 11.0714",
    stroke: "#61CBC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2858 18.0286C29.2851 16.6688 28.9608 15.3287 28.3398 14.119C27.7188 12.9092 26.8188 11.8646 25.7144 11.0714",
    stroke: "#61CBC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_9910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.580d4050790b0c0b530e492690704004.svg";
export { ForwardRef as ReactComponent };